import React from 'react';

// loading component for suspense fallback
export default function Loader(): JSX.Element {
    return (
        <div className="App">
            <div>loading...</div>
        </div>
    );
};